<template>
  <Widget class="bg-red-600 text-white border-red-700">
    <WidgetHeader class="bg-red-600 text-white"
      ><span class="text-white">Are you sure?</span></WidgetHeader
    >
    <WidgetBody>
      <h5 class="text-yellow-400 font-bold">This action cannot be undone.</h5>
    </WidgetBody>
    <WidgetFooter class="bg-dark-transparent-1 flex justify-between py-2 px-4">
      <YButton class="hover:bg-red-700 focus:bg-red-700" @click="$emit('close')"
        >Cancel</YButton
      >
      <YButton
        @click="deleteLead"
        class="bg-red-900 hover:bg-red-700 focus:bg-red-700"
        :is-loading="isSubmitting"
        >Delete Lead</YButton
      >
    </WidgetFooter>
  </Widget>
</template>

<script>
import ValidationErrorsMixin from '@/mixins/ValidationErrorsMixin'
import gql from 'graphql-tag'

export default {
  mixins: [ValidationErrorsMixin],
  props: {
    id: { type: String, required: true }
  },
  data() {
    return {
      isSubmitting: false
    }
  },
  methods: {
    deleteLead() {
      this.isSubmitting = true
      this.$apollo
        .mutate({
          mutation: gql`
            mutation DeleteLead($id: ID!) {
              deleteLead(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.id
          }
        })
        .then(() => {
          this.isSubmitting = false
          this.clearValidationErrors()
          this.$events.emit('leadDeleted')
          this.$emit('close')
        })
        .catch(error => {
          console.log(error)
          this.$toastr.e(error, 'Something went wrong. Lead not deleted')
          this.setValidationErrors(error)
          this.isSubmitting = false
        })
    }
  }
}
</script>
